import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
// Medsurf Lib
// -- Components
import * as FlatComponents from '@medsurf/flat-components';
// -- Pipes
import * as FlatPipes from '@medsurf/flat-pipes';
// -- Directives
import * as FlatDirectives from '@medsurf/flat-directives';
// Modules
// -- Prime Ng
import { AccordionModule } from "primeng/accordion";
import { AutoFocusModule } from "primeng/autofocus";
import { BlockUIModule } from "primeng/blockui";
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { DataViewModule } from 'primeng/dataview';
import { DialogService, DynamicDialogConfig, DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { InplaceModule } from 'primeng/inplace';
import { InputGroupModule } from "primeng/inputgroup";
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { ImageModule } from 'primeng/image';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from "primeng/messages";
import { MultiSelectModule } from 'primeng/multiselect';
import { SplitButtonModule } from 'primeng/splitbutton';
import { PanelModule } from 'primeng/panel';
import { PaginatorModule } from 'primeng/paginator';
import { PasswordModule } from 'primeng/password';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RippleModule } from 'primeng/ripple';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SplitterModule } from 'primeng/splitter'
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TabMenuModule } from 'primeng/tabmenu';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { TreeModule } from 'primeng/tree';
import { SliderModule } from 'primeng/slider';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TreeTableModule } from 'primeng/treetable';
import { ChipsModule } from 'primeng/chips';
import { DividerModule } from 'primeng/divider';
// -- Others
import { DragulaModule } from 'ng2-dragula';
import { ColorPickerModule } from 'ngx-color-picker';
import { EditorModule } from '@tinymce/tinymce-angular';
// Content
import * as DesignContent from './content/index';
// Form
import * as DesignForm from './form-control/index';
// Input
import * as DesignInput from './input/index';

@NgModule({
  declarations: [
    // Medsurf Lib
    // -- Components
    FlatComponents.ModalControlComponent,
    FlatComponents.ImageLoaderSharedComponent,
    FlatComponents.SearchControlComponent,
    // -- Pipes
    FlatPipes.DateSharedPipe,
    FlatPipes.DurationSharedPipe,
    FlatPipes.HighlightViewerPipe,
    FlatPipes.LogSharedPipe,
    FlatPipes.FileSizePipe,
    FlatPipes.SafeHtmlSharedPipe,
    FlatPipes.SortBySharedPipe,
    FlatPipes.StripTagsPipe,
    // -- Directive
    FlatDirectives.BlockUiSharedDirective,
    FlatDirectives.DisableControlSharedDirective,
    // Input
    DesignInput.ButtonInputDesign,
    DesignInput.CheckboxInputDesign,
    DesignInput.LinkInputDesign,
    DesignInput.MenuInputDesign,
    DesignInput.MultiSelectInputDesign,
    DesignInput.RadioButtonInputDesign,
    DesignInput.SplitButtonInputDesign,
    DesignInput.SwitchInputDesign,
    DesignInput.TextInputDesign,
    DesignInput.TextareaInputDesign,
    DesignInput.UploadInputDesign,
    // Content
    DesignContent.BreadcrumbContentDesign,
    DesignContent.CardContentDesign,
    DesignContent.ChipContentDesign,
    DesignContent.CollapsiblePanelContentDesign,
    DesignContent.ImageContentDesign,
    DesignContent.InputGroupContentDesign,
    DesignContent.MessageContentDesign,
    DesignContent.PanelContentDesign,
    DesignContent.ProcessSpinnerContentDesign,
    DesignContent.ScrollPanelContentDesign,
    DesignContent.SortableDataViewContentDesign,
    DesignContent.SortableDataViewLayoutOptionsContentDesign,
    DesignContent.TagContentDesign,
    DesignContent.TemplateNodeTreeContentDesign,
    DesignContent.TemplateSlideTreeContentDesign,
    DesignContent.ToolbarContentDesign,
    // Form
    DesignForm.FormFormControlDesign,
    // -- Input
    DesignForm.FormInput.CheckboxInputFormControlDesign,
    DesignForm.FormInput.ColorPickerInputFormControlDesign,
    DesignForm.FormInput.DropdownInputFormControlDesign,
    DesignForm.FormInput.MultiSelectInputFormControlDesign,
    DesignForm.FormInput.NodeTreeSelectInputFormControlDesign,
    DesignForm.FormInput.NumberInputFormControlDesign,
    DesignForm.FormInput.PivotInputFormControlDesign,
    DesignForm.FormInput.RouteInputTextInputFormControlDesign,
    DesignForm.FormInput.SelectButtonInputFormControlDesign,
    DesignForm.FormInput.SliderInputFormControlDesign,
    DesignForm.FormInput.SubmitInputFormControlDesign,
    DesignForm.FormInput.SwitchInputFormControlDesign,
    DesignForm.FormInput.TextInputFormControlDesign,
    DesignForm.FormInput.TextareaInputFormControlDesign,
    DesignForm.FormInput.ThemeColorSelectButtonInputFormControlDesign,
    DesignForm.FormInput.WatermarkPositionSelectButtonInputFormControlDesign,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    // Modules
    // -- Prime Ng
    AccordionModule,
    AutoFocusModule,
    BreadcrumbModule,
    ButtonModule,
    CardModule,
    CheckboxModule,
    ChipModule,
    DataViewModule,
    DynamicDialogModule,
    DropdownModule,
    FileUploadModule,
    InplaceModule,
    InputGroupModule,
    InputSwitchModule,
    InputNumberModule,
    InputTextareaModule,
    InputTextModule,
    ImageModule,
    OverlayPanelModule,
    MenuModule,
    MessageModule,
    MessagesModule,
    MultiSelectModule,
    SplitButtonModule,
    PanelModule,
    PaginatorModule,
    PasswordModule,
    ProgressSpinnerModule,
    RippleModule,
    SelectButtonModule,
    ScrollPanelModule,
    SplitterModule,
    TabMenuModule,
    SkeletonModule,
    TableModule,
    TabViewModule,
    ToggleButtonModule,
    TagModule,
    ToastModule,
    ToolbarModule,
    TreeModule,
    SliderModule,
    RadioButtonModule,
    TreeTableModule,
    ChipsModule,
    DividerModule,
    // -- Others
    DragulaModule.forRoot(),
    ColorPickerModule,
    EditorModule,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    // Medsurf Lib
    // -- Components
    FlatComponents.ModalControlComponent,
    FlatComponents.ImageLoaderSharedComponent,
    FlatComponents.SearchControlComponent,
    // -- Pipes
    FlatPipes.DateSharedPipe,
    FlatPipes.DurationSharedPipe,
    FlatPipes.HighlightViewerPipe,
    FlatPipes.LogSharedPipe,
    FlatPipes.FileSizePipe,
    FlatPipes.SafeHtmlSharedPipe,
    FlatPipes.SortBySharedPipe,
    FlatPipes.StripTagsPipe,
    // -- Directive
    FlatDirectives.BlockUiSharedDirective,
    FlatDirectives.DisableControlSharedDirective,
    // Modules
    // -- Prime Ng
    AccordionModule,
    BlockUIModule,
    ButtonModule,
    DataViewModule,
    SplitButtonModule,
    DynamicDialogModule,
    InputGroupModule,
    MenuModule,
    MessagesModule,
    ProgressBarModule,
    RippleModule,
    SplitterModule,
    TagModule,
    DividerModule,
    ToastModule,
    TableModule,
    DropdownModule,
    TabViewModule,
    ToggleButtonModule,
    TabMenuModule,
    SliderModule,
    RadioButtonModule,
    ReactiveFormsModule,
    // Content
    // -- Others
    DragulaModule,
    ColorPickerModule,
    // Input
    DesignInput.ButtonInputDesign,
    DesignInput.CheckboxInputDesign,
    DesignInput.LinkInputDesign,
    DesignInput.MenuInputDesign,
    DesignInput.MultiSelectInputDesign,
    DesignInput.RadioButtonInputDesign,
    DesignInput.SplitButtonInputDesign,
    DesignInput.SwitchInputDesign,
    DesignInput.TextInputDesign,
    DesignInput.TextareaInputDesign,
    DesignInput.UploadInputDesign,
    // Content
    DesignContent.BreadcrumbContentDesign,
    DesignContent.CardContentDesign,
    DesignContent.ChipContentDesign,
    DesignContent.CollapsiblePanelContentDesign,
    DesignContent.ImageContentDesign,
    DesignContent.InputGroupContentDesign,
    DesignContent.MessageContentDesign,
    DesignContent.PanelContentDesign,
    DesignContent.ProcessSpinnerContentDesign,
    DesignContent.ScrollPanelContentDesign,
    DesignContent.SortableDataViewContentDesign,
    DesignContent.SortableDataViewLayoutOptionsContentDesign,
    DesignContent.TagContentDesign,
    DesignContent.TemplateNodeTreeContentDesign,
    DesignContent.TemplateSlideTreeContentDesign,
    DesignContent.ToolbarContentDesign,
    // Form
    DesignForm.FormFormControlDesign,
    // -- Input
    DesignForm.FormInput.CheckboxInputFormControlDesign,
    DesignForm.FormInput.ColorPickerInputFormControlDesign,
    DesignForm.FormInput.DropdownInputFormControlDesign,
    DesignForm.FormInput.MultiSelectInputFormControlDesign,
    DesignForm.FormInput.NodeTreeSelectInputFormControlDesign,
    DesignForm.FormInput.NumberInputFormControlDesign,
    DesignForm.FormInput.PivotInputFormControlDesign,
    DesignForm.FormInput.RouteInputTextInputFormControlDesign,
    DesignForm.FormInput.SelectButtonInputFormControlDesign,
    DesignForm.FormInput.SliderInputFormControlDesign,
    DesignForm.FormInput.SubmitInputFormControlDesign,
    DesignForm.FormInput.SwitchInputFormControlDesign,
    DesignForm.FormInput.TextInputFormControlDesign,
    DesignForm.FormInput.TextareaInputFormControlDesign,
    DesignForm.FormInput.ThemeColorSelectButtonInputFormControlDesign,
    DesignForm.FormInput.WatermarkPositionSelectButtonInputFormControlDesign,
    /* Check These
    DesignInput.SelectButtonInputFormControlDesign,
    DesignInput.NumberInputDesignComponent
    */
  ],
  providers: [
    DialogService,
    DynamicDialogRef,
    DynamicDialogConfig,
  ]
})
export class FlatDesignModule {}
